import { Component } from '@angular/core';

@Component({
  selector: 'app-web-layout',
  templateUrl: './web-layout.component.html',
  styleUrl: './web-layout.component.scss'
})
export class WebLayoutComponent {

}
